// extracted by mini-css-extract-plugin
module.exports = {"error":"Select_error__Zmu0P","errorText":"Select_errorText__DanuD","arrow":"Select_arrow__BQOPK"};